import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { connectStream } from '../../lib/bastetjs/utils/connectStream';
import {
  fetchAthlete,
  getAthleteStream,
} from '../../data/AthleteStreams';
import { PrivateProfile } from '../privateProfile/privateProfile';
import {
  tabTypes
} from '../../utils/ProfileUtil';
import { AthletePage } from './AthletePage';

class AthletePageContainerComponent extends Component {
  static propTypes = {
    athleteId: PropTypes.string.isRequired,
    selectedRival: PropTypes.string,
    tab: PropTypes.oneOf(tabTypes),
    athlete: PropTypes.object,
    auth: PropTypes.object,
    t: PropTypes.func,
    isMobile: PropTypes.bool,
    windowWidth: PropTypes.number
  };

  componentDidMount() {
    fetchAthlete(this.props.athleteId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextAthleteId = nextProps.athleteId;
    if (nextAthleteId && nextAthleteId !== this.props.athleteId) {
      fetchAthlete(nextAthleteId);
    }
  }

  render() {
    const {
      athlete = {},
      athleteId,
      auth,
      isMobile,
      selectedRival,
      tab,
      windowWidth
    } = this.props;

    const fetching = athlete.fetching;

    if (fetching) {
      return null
    }

    if (!athlete.athlete) {
      return (
        <PrivateProfile />
      )
    }

    return (
      <AthletePage
        athleteId={athleteId}
        auth={auth}
        tab={tab}
        selectedRival={selectedRival}
        isMobile={isMobile}
        windowWidth={windowWidth}
      />
    )
  }
}

export const AthletePageContainer = withTranslation()(connectStream({
  athlete: ({athleteId}) => getAthleteStream(athleteId)
})(AthletePageContainerComponent));



/** WEBPACK FOOTER **
 ** ./views/athlete/AthletePageContainer.js
 **/